import { AlertTriangle } from "lucide-react";
import { arrivedLegsLabel, type LegWithArrivedTrailer } from "@/lib/order-trailer-arrival";

/**
 * "Trailer arrived · pending check-in" warning line under the Orders list's
 * order id: EAPI reported a leg's
 * trailer at the yard and nobody has checked it in (and inspected it) yet.
 * Pass every leg of the order; on a multi-leg order the chip names the legs
 * ("Leg 2 trailer arrived · pending check-in"). Renders nothing otherwise.
 */
export function TrailerArrivedBadge({ legs }: { legs: LegWithArrivedTrailer[] }) {
  const label = arrivedLegsLabel(legs);
  if (!label) return null;
  return (
    <div className="mt-0.5 flex items-center gap-1 text-xs text-amber-700 dark:text-amber-300 whitespace-nowrap">
      <AlertTriangle className="h-3 w-3 shrink-0" />
      {label}
    </div>
  );
}
